import { useCallback } from 'react';
import { Contact } from '../../components/address-book';
import { AddressForm } from '../../global-types';
import { AddressData } from '../../global-types/addresses';
import { useInitializationDataContext } from './data-context';
import { updateAddresses, updateAddressType, updateContacts } from './data-context-actions';

export const useDataContext = () => {
  const { initializedDataState, initializationDataDispatch } = useInitializationDataContext();

  const setSavedContacts: (contacts: Contact[]) => void = useCallback(
    (contacts) => {
      updateContacts(initializationDataDispatch, contacts ?? []);
    },
    [initializationDataDispatch],
  );

  // resetSenderAndRecipientAddresses removes all the addresses from the state including the sender and recipient
  const resetSenderAndRecipientAddresses: () => void = useCallback(() => {
    updateAddresses(initializationDataDispatch, { recipient: undefined, sender: undefined });
  }, [initializationDataDispatch]);

  const setAddressData: (params: { recipient?: AddressData; sender?: AddressData }) => void = useCallback(
    async ({ recipient, sender }) => {
      updateAddresses(initializationDataDispatch, { recipient, sender });
    },
    [initializationDataDispatch],
  );

  const setRecipientAddress: (address: AddressForm) => void = useCallback(
    (address) => {
      updateAddresses(initializationDataDispatch, { recipient: address });
    },
    [initializationDataDispatch],
  );

  const setSenderAddress: (address: AddressForm) => void = useCallback(
    (address) => {
      updateAddresses(initializationDataDispatch, { sender: address });
    },
    [initializationDataDispatch],
  );

  const setIsRecipientAddress: (isRecipientAddress: boolean) => void = useCallback(
    (isRecipientAddress) => {
      updateAddressType(initializationDataDispatch, isRecipientAddress);
    },
    [initializationDataDispatch],
  );

  return {
    setSavedContacts,
    resetSenderAndRecipientAddresses,
    setAddressData,
    setRecipientAddress,
    setSenderAddress,
    setIsRecipientAddress,
    initializedDataState,
  };
};
